import deleteSiteMeta from '../base-saving-actions/delete-site-meta';

const deleteCustomFontPairs = (fontPairsIds) =>
  fontPairsIds.map((id) => deleteSiteMeta(['customization', 'customFontPairs', id]));

export default deleteCustomFontPairs;
